import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, UpdateWebhookDialogueHandler } from './types';
import WebhookContext from './UpdateWebhookContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type WebhookDialogueProps = {
  handleDialogue: DialogueHandler<UpdateWebhookDialogueHandler>;
};

type FC = FunctionComponent<WebhookDialogueProps>;

const UpdateWebhookDialogue: FC = ({ handleDialogue }: WebhookDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, updateErrors } = useContext(WebhookContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.Update.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('UpdateError.title')}
          status="error"
          subTitle={
            <ul style={{ textAlign: 'left', margin: 0 }}>
              {updateErrors.map((error) => (
                <li key={error.label}>{`${error.label}: ${error.message}`}</li>
              ))}
            </ul>
          }
          confirm={{
            label: t('UpdateError.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('UpdateSuccess.title')}
          status="success"
          subTitle={t('UpdateSuccess.subTitle')}
          confirm={{
            label: t('UpdateSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert, updateErrors],
  );
};

export default UpdateWebhookDialogue;
